'use client';

import React from 'react';
import styled from '@benzinga/themetron';

type DividerDirection = 'horizontal' | 'vertical';

export interface DividerProps {
  direction?: DividerDirection;
  children?: React.ReactNode;
  thickness?: 'thick' | 'thin';
}

export const Divider: React.FC<DividerProps> = ({ children, direction = 'horizontal', thickness = 'thick' }) => {
  return <Container className={`divider ${direction} ${thickness}`}>{children}</Container>;
};

export default Divider;

const Container = styled.div`
  &.divider {
    display: flex;
    flex-direction: row;
    align-items: center;
    align-self: stretch;
    height: 1rem;
    white-space: nowrap;

    &:not(:empty) {
      gap: 1rem;
      margin-top: 1rem;
      margin-bottom: 1rem;
    }

    &:before,
    &:after {
      content: '';
      flex-grow: 1;
      height: 0.125rem;
      width: 100%;
      background-color: ${({ theme }) => theme.colorPalette.gray300};
    }

    &.thin {
      &:before,
      &:after {
        height: 0.05rem;
      }
    }

    &.thick {
      &:before,
      &:after {
        height: 0.125rem;
      }
    }

    &.vertical {
      flex-direction: column;
      margin-top: 0;
      margin-bottom: 0;
      margin-left: 1rem;
      margin-right: 1rem;
      height: 100%;
      width: 1rem;

      &:before,
      &:after {
        height: 100%;
        width: 0.125rem;
      }
    }
  }
`;
